// @flow

import { put, takeEvery } from 'redux-saga/effects';
import { 
  GET_LAYERS_CONFIG,
} from './../types/map';
import { 
    getLayersConfigSuccess, 
    getLayersConfigFail 
} from '../actions/map';

type GetLayersConfigAction = {
  axiosInstance: Object
};

type LayersConfig = {
  data: Array<Object>
};

export function* getLayersConfig(action: GetLayersConfigAction): Generator<any, void, any> {
  try {
    const { axiosInstance, id }: GetLayersConfigAction = action;
    const url: string = `projects/${String(id)}/layers`;
    const { data }: LayersConfig = yield axiosInstance.get(url);
    yield put(getLayersConfigSuccess(data));
  }
  catch (error) {
    yield put(getLayersConfigFail(error));
  }
}

export function* watchGetLayersConfig(): Generator<any, void, any> {
  yield takeEvery(GET_LAYERS_CONFIG, getLayersConfig);
} 


// WEBPACK FOOTER //
// ./src/sagas/map.jsx